module.exports = __webpack_public_path__ + "static/media/actions-enable.2e3d7005.png";